/* eslint-disable no-underscore-dangle */
import find from 'lodash/find';
import DashboardConst from '@/constants/dashboard';

export default (() => {
  let _self = null;
  const _editHistoryStack = [];

  return {
    apply(self) {
      _self = self;
    },
    clear() {
      _self = null;
      _editHistoryStack.length = 0;
    },
    addEditHistory(history) {
      _editHistoryStack.push(history);
    },
    clearEditHistoryStack() {
      _editHistoryStack.length = 0;
    },
    undoEditHistory() {
      try {
        const history = _editHistoryStack.pop();

        if (history) {
          switch (history.type) {
            case DashboardConst.HISTORY_TYPE.ADD: {
              history.elements.forEach((widgetId) => {
                _self.$store.commit('removeWidget', widgetId);
              });
              _self.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.WIDGET_ACTIVE_CHANGE);
              break;
            }

            case DashboardConst.HISTORY_TYPE.REMOVE: {
              history.elements.forEach((element) => {
                _self.$store.commit('updateWidget', element.widget);
                _self.$store.commit('addWidgetLayout', element.layout);
              });
              break;
            }

            case DashboardConst.HISTORY_TYPE.LOCATION:
              history.elements.forEach((widget) => {
                const tmpWidget = find(_self.$store.getters.getDashboardData.layoutInfo, ['i', widget.i]);

                _self.$set(tmpWidget, 'x', widget.x);
                _self.$set(tmpWidget, 'y', widget.y);
              });
              break;

            case DashboardConst.HISTORY_TYPE.SIZE:
              history.elements.forEach((widget) => {
                const tmpWidget = find(_self.$store.getters.getDashboardData.layoutInfo, ['i', widget.i]);

                _self.$set(tmpWidget, 'x', widget.x);
                _self.$set(tmpWidget, 'y', widget.y);
                _self.$set(tmpWidget, 'w', widget.w);
                _self.$set(tmpWidget, 'h', widget.h);

                _self.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.WIDGET_RESIZE, {
                  widgetId: widget.i,
                  newH: widget.h,
                  newW: widget.w,
                });
              });
              break;

            case DashboardConst.HISTORY_TYPE.ALIGN:
              history.elements.forEach((widget) => {
                const tmpWidget = find(_self.$store.getters.getDashboardData.layoutInfo, ['i', widget.i]);

                _self.$set(tmpWidget, 'x', widget.x);
                _self.$set(tmpWidget, 'y', widget.y);
                _self.$set(tmpWidget, 'z', widget.z);
              });
              break;

            default:
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
  };
})();
/* eslint-enable no-underscore-dangle */



// WEBPACK FOOTER //
// ./src/views/dashboard/js/edit-history.js